import React, { Component } from "react";

class Guidelines extends Component {
  render() {
    return (
      <main id="guidelines">
        <h1 className="mt4 mb4">Guidelines</h1>
        <h3>What to Submit</h3>
        <p className="mb4 f10pt fw2 lh-p">
          On-Topic: Anything that the machine learning, deep learning, or AI
          community would find interesting. This includes much more
          than tutorials, arXiv papers, and news articles. Submit something to
          MLN when you feel it has serious intellectual merit and will likely
          capture the interest of others in the community as it has you.
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          Off-Topic: Anything which is not directly related to machine learning,
          deep learning, data science, AI, or recent breakthroughs in technology
          which might affect these fields. For instance, most stories about
          politics would be off-topic; but if a new law is passed which affects
          how machine learning is practiced, implemented, or included in a
          product, that would be on-topic.
        </p>
        <h3>In Submissions</h3>
        <p className="mb4 f10pt fw2 lh-p">
          Please don't use uppercase, exclamation points, asterisks, or similar
          means to make titles stand out. This makes posts look more spammy than
          credible and they will be delisted.
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          Please refrain from editorializing in title submissions.
          The most appealing titles are succinct and informative.
          This means omitting clickbaity numbers and
          fluffy adjectives. For instance, “Methods for X” is always preferable
          to “5 Awesome Methods For X You Need To Know.”
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          Try to respect original sources. If you see that a post reports on
          something found on another site, try to reference the original site.
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          Most posts point to articles -- if you submit a video or pdf, go ahead
          and append [video] or [pdf] to the title.
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          Please avoid link shorteners. Submit full, original URLs so they will
          be guaranteed to display correctly on the homepage.
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          Please self-regulate your posting frequency. The “new” page should
          never have more than a couple of posts from the same user.
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          Please refrain from deleting and reposting the same story. Others will
          notice. We’ll notice and deactivate your account for spamming.
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          Don't solicit upvotes, comments, or submissions. These should occur
          organically because the content is inherently interesting, not because
          somebody has something they’re trying to promote.
        </p>
        <h3>In Comments</h3>
        <p className="mb4 f10pt fw2 lh-p">
          Be kind. Seed conversation with genuine curiosity.
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          Criticize ideas, not people. Rude or disparaging remarks are
          unwelcome, unproductive, and only serve to degrade discussion.
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          ML News is for interesting content and intellectual discussion, not
          for political or ideological debates.
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          If you disagree with someone, give a reason. If you don’t like
          something, give a reason. It’s always helpful to substantiate claims
          with references to their source.
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          Using uppercase to emphasize a point is like shouting in somebody’s
          head. Please don’t do it.
        </p>
        <p className="mb4 f10pt fw2 lh-p">
          Comments are not for complaining that a submission is off-topic, spam,
          shilling, or the like. If you think a post is off-topic, flag it. If
          you’re worried about dishonest intentions, email us and we’ll look
          into it.
        </p>
      </main>
    );
  }
}

export default Guidelines;



// WEBPACK FOOTER //
// ./src/components/Guidelines.js